import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import annualRevenueSrc from 'components/icons/attendeeEnrichmentData/annualRevenue.svg';
import employeesSrc from 'components/icons/attendeeEnrichmentData/employees.svg';
import senioritySrc from 'components/icons/attendeeEnrichmentData/seniority.svg';

const UserDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 18px;
`;

const AttendeeTagContainer = styled.div`
  height: 32px;
  font-size: 14px;
  padding: 8px 0;
  display: flex;
`;

const AttendeeTagIconContainer = styled.div`
  width: 32px;
  height: 100%;
  flex: 0 0 24px;
`;

const AttendeeTagIcon = styled.img`
  width: 16px;
  height: 16px;
`;

const AttendeeDetailsContainer = styled.pre`
  font-family: Lato, san-serif;
  margin: 0;
`;

interface UserDetailsContainerProps {
  seniority: string;
  employees: number;
  estimatedAnnualRevenue: string
}

const UserDetails: FC<UserDetailsContainerProps> = ({
  seniority,
  employees,
  estimatedAnnualRevenue,
}) => {
  const { t } = useTranslation();
  if (seniority || employees || estimatedAnnualRevenue) {
    return (
      <UserDetailsContainer>
        {seniority && (
          <AttendeeTagContainer>
            <AttendeeTagIconContainer>
              <AttendeeTagIcon src={senioritySrc} alt="seniority" />
            </AttendeeTagIconContainer>
            <AttendeeDetailsContainer>
              <strong>{t(`attendee_enrichment.${seniority}`, seniority)}</strong>
            </AttendeeDetailsContainer>
          </AttendeeTagContainer>
        )}
        {employees && (
          <AttendeeTagContainer>
            <AttendeeTagIconContainer>
              <AttendeeTagIcon src={employeesSrc} alt="employees" />
            </AttendeeTagIconContainer>
            <AttendeeDetailsContainer>
              {t('attendee_enrichment.employees', 'Employees')}
              <strong>{` ${employees}`}</strong>
            </AttendeeDetailsContainer>
          </AttendeeTagContainer>
        )}
        {estimatedAnnualRevenue && (
          <AttendeeTagContainer>
            <AttendeeTagIconContainer>
              <AttendeeTagIcon src={annualRevenueSrc} alt="annualRevenue" />
            </AttendeeTagIconContainer>
            <AttendeeDetailsContainer>
              {t('attendee_enrichment.annual_revenue', 'Annual Revenue')}
              <strong>{` ${estimatedAnnualRevenue}`}</strong>
            </AttendeeDetailsContainer>
          </AttendeeTagContainer>
        )}
      </UserDetailsContainer>
    );
  }
  return null;
};

export default UserDetails;
